module.exports = __webpack_public_path__ + "static/media/hcs-logo2.d6900895.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/hcs-logo2.png
// module id = 1592
// module chunks = 14